export default "__VITE_PUBLIC_ASSET__14d77dbf__"